import { InlineExternalLink } from '@monash/portal-react';

export const LINK_TYPES = {
  LINK: 'link',
  SERVICE: 'service',
  EXPERIENCE: 'experience',
};

export const LINK_TYPE_OPTIONS = [
  { label: 'Link', value: LINK_TYPES.LINK },
  { label: 'Service', value: LINK_TYPES.SERVICE },
  { label: 'Experience', value: LINK_TYPES.EXPERIENCE },
];

export const MIN_LINKS = 1;

export const MAX_LINKS = 2;

export const EMPTY_LINK_DATA = {
  text: '',
  url: '',
};

export const EMPTY_PERSONALISATION_TAG_DATA = {
  value: '',
};

export const MIN_PERSONAS = 1;

export const LINK_TEXT_OPTIONS = [
  { text: 'View details', value: 'View details' },
  { text: 'Apply', value: 'Apply' },
  { text: 'Register', value: 'Register' },
];

export const LINKS_EMPTY_VALUES = {
  linkType: LINK_TYPES.LINK,
  name: '',
  icon: '',
  description: '',
  longDescription: '',
  categories: [],
  links: [{ ...EMPTY_LINK_DATA }],
  imageUrl: '',
  displayLabel: '',
  personalisationTags: [{ ...EMPTY_PERSONALISATION_TAG_DATA }],
  relevance: '',
  filters: [],
  tags: [],
  status: '',
  startDate: null,
};

export const LINKS_INLINE_ERROR_MSGS = {
  TYPE: 'You must select a type',
  ICON: 'You must provide an icon',
  URL: 'You must provide a url',
  CATEGORY: 'You must select a category',
  SUB_CATEGORY: 'You must select a sub category',
  CATEGORY_WEIGHT: 'Weight must be between 0-9',
  RELEVANCE: 'Weighting must be between 0-20',
  PERSONALISATION_TAGS: 'You must select a persona',
};

export const MIN_CATEGORY_WEIGHT = 0;

export const MAX_CATEGORY_WEIGHT = 9;

export const MIN_RELEVANCE = 0;

export const MAX_RELEVANCE = 20;

// server error messages (5xx)
export const LINKS_SERVER_ERROR_MSGS = {
  DRAFT: "We're having trouble saving the link right now - please try again.",
  PUBLISH:
    "We're having trouble publishing the link right now - please try again.",
  DELETE:
    "We're having trouble deleting the link right now - please try again.",
  ARCHIVE:
    "We're having trouble archiving the link right now - please try again.",
};

// client error messages (4xx)
export const LINKS_CLIENT_ERROR_MSGS = {
  DRAFT: (
    <>
      We're having trouble saving the link - please{' '}
      <InlineExternalLink
        text="log a bug"
        link="https://admin.staff.monash/feedback"
      />
    </>
  ),
  PUBLISH: (
    <>
      We're having trouble publishing the link - please{' '}
      <InlineExternalLink
        text="log a bug"
        link="https://admin.staff.monash/feedback"
      />
    </>
  ),
  DELETE: (
    <>
      We're having trouble deleting the link - please{' '}
      <InlineExternalLink
        text="log a bug"
        link="https://admin.staff.monash/feedback"
      />
    </>
  ),
  ARCHIVE: (
    <>
      We're having trouble archiving the link - please{' '}
      <InlineExternalLink
        text="log a bug"
        link="https://admin.staff.monash/feedback"
      />
    </>
  ),
};
